function initRiskMapForm() {
    const form = document.getElementById("risk-map-form");

    if (!form) return;

    if (form.dataset.riskMapBound === "true") return;
    form.dataset.riskMapBound = "true";

    const facultySelect = document.getElementById("risk_map_faculty_id");
    const yearInput = document.getElementById("risk_map_year");
    const macroProcessSelect = document.getElementById("risk_map_macro_process_id");
    const linesContainer = document.getElementById("risk-map-lines");
    const addLineButton = document.getElementById("add-risk-map-line");

    const processSectionsContainer = document.getElementById("risk-map-process-sections");
    const lineTemplate = document.getElementById("risk-map-line-template");

    if (!facultySelect || !yearInput || !macroProcessSelect || !processSectionsContainer) return;

    function resetSelect(select, placeholder) {
        select.innerHTML = "";

        const option = document.createElement("option");
        option.value = "";
        option.textContent = placeholder;

        select.appendChild(option);
    }

    function resetProcessSections() {
        processSectionsContainer.innerHTML = "";
    }

    function processSectionHtml(process) {
        return `
        <div class="card mb-4 risk-map-process-section" data-mprocess-id="${process.id}">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <strong>${process.text}</strong>

                <button type="button"
                        class="btn btn-sm btn-primary skip-loading add-risk-map-line"
                        data-mprocess-id="${process.id}">
                    Agregar línea
                </button>
            </div>

            <div class="table-responsive">
                <table class="table table-bordered align-middle mb-0 risk-map-lines-table">
                    <thead class="table-light text-center">
                        <tr>
                            <th style="min-width: 220px;">(1) Subproceso</th>
                            <th style="min-width: 220px;">(2) Riesgos</th>
                            <th style="min-width: 260px;">(3) Descripción</th>
                            <th style="min-width: 220px;">(4) Agente generador</th>
                            <th style="min-width: 240px;">(5) Causas</th>
                            <th style="min-width: 240px;">(6) Efectos</th>
                            <th style="min-width: 150px;">(7) Probabilidad</th>
                            <th style="min-width: 150px;">(8) Impacto</th>
                            <th style="min-width: 130px;">(9) Calificación</th>
                            <th style="min-width: 240px;">(10) Evaluación</th>
                            <th style="min-width: 300px;">(11) Medidas de Respuesta</th>
                            <th style="min-width: 300px;">(12) Descripción de Medidas</th>
                            <th style="width: 80px;"></th>
                        </tr>
                    </thead>

                    <tbody class="risk-map-lines" data-mprocess-id="${process.id}"></tbody>
                </table>
            </div>
        </div>
    `;
    }

    function loadMProcesses() {
        const macroProcessId = macroProcessSelect.value;

        resetProcessSections();

        if (!macroProcessId) return;

        fetch(`/risk_maps/mprocesses_by_macro_process?macro_process_id=${macroProcessId}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando procesos");
                return response.json();
            })
            .then(function (data) {
                data.forEach(function (process) {
                    processSectionsContainer.insertAdjacentHTML("beforeend", processSectionHtml(process));
                });
            })
            .catch(function (error) {
                console.error(error);
            });
    }

    function addLineToProcess(mprocessId) {
        if (!lineTemplate) return;

        const container = document.querySelector(`.risk-map-lines[data-mprocess-id="${mprocessId}"]`);
        if (!container) return;

        const newId = new Date().getTime();
        const html = lineTemplate.innerHTML.replace(/NEW_RECORD/g, newId);

        container.insertAdjacentHTML("beforeend", html);

        const row = container.lastElementChild;

        const mprocessInput = row.querySelector(".risk-map-line-mprocess-id");
        if (mprocessInput) {
            mprocessInput.value = mprocessId;
        }

        bindLineEvents(row);
        row.dataset.bound = "true";

        const subProcessSelect = row.querySelector(".risk-map-sub-process");

        if (subProcessSelect) {
            fetch(`/risk_maps/sub_processes_by_mprocess?mprocess_id=${mprocessId}`)
                .then(function (response) {
                    if (!response.ok) throw new Error("Error cargando subprocesos");
                    return response.json();
                })
                .then(function (data) {
                    fillSingleSubProcessSelect(subProcessSelect, data, "Seleccione", null);
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    }

    function fillSingleSubProcessSelect(select, records, placeholder, selectedValue) {
        resetSelect(select, placeholder);

        records.forEach(function (record) {
            const option = document.createElement("option");
            option.value = record.id;
            option.textContent = record.text;

            if (selectedValue && selectedValue.toString() === record.id.toString()) {
                option.selected = true;
            }

            select.appendChild(option);
        });
    }

    function fillSelect(select, records, placeholder) {
        resetSelect(select, placeholder);

        records.forEach(function (record) {
            const option = document.createElement("option");
            option.value = record.id;
            option.textContent = record.text;
            select.appendChild(option);
        });
    }

    function resetSubProcessSelects() {
        document.querySelectorAll(".risk-map-sub-process").forEach(function (select) {
            resetSelect(select, "Seleccione");
        });
    }

    function loadMacroProcesses() {
        const facultyId = facultySelect.value;
        const year = yearInput.value;

        resetSelect(macroProcessSelect, "Seleccione un macroproceso");
        resetSubProcessSelects();

        if (!facultyId || !year) return;

        fetch(`/risk_maps/macro_processes_by_faculty_year?faculty_id=${facultyId}&year=${year}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Error cargando macroprocesos");
                return response.json();
            })
            .then(function (data) {
                fillSelect(macroProcessSelect, data, "Seleccione un macroproceso");
            })
            .catch(function (error) {
                console.error(error);
            });
    }
    function riskEvaluation(probability, impact) {
        const key = `${probability}-${impact}`;

        const values = {
            "3-5": "Zona de Riesgo Moderado",
            "2-5": "Zona de Riesgo Tolerable",
            "1-5": "Zona de Riesgo Aceptable",
            "3-10": "Zona de Riesgo Importante",
            "2-10": "Zona de Riesgo Moderado",
            "1-10": "Zona de Riesgo Tolerable",
            "3-20": "Zona de Riesgo Inaceptable",
            "2-20": "Zona de Riesgo Importante",
            "1-20": "Zona de Riesgo Tolerable"
        };

        return values[key] || "";
    }

    function responseMeasures(probability, impact) {
        const key = `${probability}-${impact}`;

        const values = {
            "3-5": "Prevenir el riesgo.",
            "2-5": "Aceptar el riesgo. Prevenir el riesgo.",
            "1-5": "Aceptar el riesgo.",
            "3-10": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-10": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "1-10": "Proteger la Institución. Compartir.",
            "3-20": "Evitar el riesgo. Prevenir el riesgo. Proteger la Institución. Compartir.",
            "2-20": "Prevenir el riesgo. Proteger la Institución. Compartir.",
            "1-20": "Proteger la Institución. Compartir."
        };

        return values[key] || "";
    }

    function calculateLine(row) {
        const probabilitySelect = row.querySelector(".risk-map-probability");
        const impactSelect = row.querySelector(".risk-map-impact");
        const qualificationInput = row.querySelector(".risk-map-qualification");
        const evaluationInput = row.querySelector(".risk-map-evaluation");
        const responseInput = row.querySelector(".risk-map-response-measures");

        if (!probabilitySelect || !impactSelect || !qualificationInput || !evaluationInput || !responseInput) return;

        const probability = parseInt(probabilitySelect.value, 10);
        const impact = parseInt(impactSelect.value, 10);

        if (!probability || !impact) {
            qualificationInput.value = "";
            evaluationInput.value = "";
            responseInput.value = "";
            return;
        }

        qualificationInput.value = probability * impact;
        evaluationInput.value = riskEvaluation(probability, impact);
        responseInput.value = responseMeasures(probability, impact);
    }

    function bindLineEvents(row) {
        row.querySelectorAll(".risk-map-probability, .risk-map-impact").forEach(function (select) {
            select.addEventListener("change", function () {
                calculateLine(row);
            });
        });

        const removeButton = row.querySelector(".remove-risk-map-line");

        if (removeButton) {
            removeButton.addEventListener("click", function () {
                const deletedInput = row.querySelector(".risk-map-line-deleted");
                const idInput = row.querySelector('input[name*="[id]"]');

                if (idInput && idInput.value) {
                    deletedInput.value = "1";
                    row.style.display = "none";
                } else {
                    row.remove();
                }
            });
        }
    }

    function bindAllLines() {
        document.querySelectorAll(".risk-map-line").forEach(function (row) {
            if (row.dataset.bound === "true") return;

            bindLineEvents(row);
            calculateLine(row);

            row.dataset.bound = "true";
        });
    }

    function addLine() {
        if (!lineTemplate || !linesContainer) return;

        const newId = new Date().getTime();
        const html = lineTemplate.innerHTML.replace(/NEW_RECORD/g, newId);

        linesContainer.insertAdjacentHTML("beforeend", html);

        const row = linesContainer.lastElementChild;

        bindLineEvents(row);
        row.dataset.bound = "true";

        const newSubProcessSelect = row.querySelector(".risk-map-sub-process");

        if (mProcessSelect.value && newSubProcessSelect) {
            fetch(`/risk_maps/sub_processes_by_mprocess?mprocess_id=${mProcessSelect.value}`)
                .then(function (response) {
                    if (!response.ok) throw new Error("Error cargando subprocesos");
                    return response.json();
                })
                .then(function (data) {
                    fillSingleSubProcessSelect(newSubProcessSelect, data, "Seleccione", null);
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    }

    facultySelect.addEventListener("change", loadMacroProcesses);
    yearInput.addEventListener("change", loadMacroProcesses);
    macroProcessSelect.addEventListener("change", loadMProcesses);

    processSectionsContainer.addEventListener("click", function (event) {
        const button = event.target.closest(".add-risk-map-line");

        if (!button) return;

        addLineToProcess(button.dataset.mprocessId);
    });

    bindAllLines();
}

document.addEventListener("DOMContentLoaded", initRiskMapForm);
document.addEventListener("turbolinks:load", initRiskMapForm);